export const formatPrice = (value: number, withoutCurrency: boolean) => {
    return `${value}`
        .split(/(?=(?:...)*$)/)
        .join(' ')
        .concat(withoutCurrency ? '' : ' ₽');
};
